var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEgg = function SvgEgg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 24,
    viewBox: "0 0 62 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.65093 17.8378C4.65093 17.8378 -2.14907 16.5378 2.65093 11.3378C7.28531 6.31725 19.75 3.37854 26.0048 2.43171C27.7202 2.40041 33.5841 1.54057 43.1509 2.33782C55.1509 3.33784 60.1509 5.33783 61.1509 11.3378C61.8862 15.7491 52.1509 15.3378 43.1509 16.3378C34.1509 17.3378 30.1509 20.8378 26.6509 22.3378C23.1509 23.8378 17.6509 20.8378 17.1509 17.8378C16.7509 15.4378 11.3176 16.8378 8.65093 17.8378Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6509 2.33782C26.4439 2.36657 26.2283 2.39787 26.0048 2.43171M26.0048 2.43171C19.75 3.37854 7.28531 6.31725 2.65093 11.3378C-2.14907 16.5378 4.65093 17.8378 8.65093 17.8378C11.3176 16.8378 16.7509 15.4378 17.1509 17.8378C17.6509 20.8378 23.1509 23.8378 26.6509 22.3378C30.1509 20.8378 34.1509 17.3378 43.1509 16.3378C52.1509 15.3378 61.8862 15.7491 61.1509 11.3378C60.1509 5.33783 55.1509 3.33784 43.1509 2.33782C33.5841 1.54057 27.7202 2.40041 26.0048 2.43171Z",
    stroke: "#F7EFE0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2139 0.0194046C21.6139 -0.380595 19.2139 5.5194 22.2139 7.0194C25.2139 8.51941 27.2139 8.0194 30.2139 8.0194C41.2139 8.0194 42.9366 6.90616 43.2139 5.51941C43.7139 3.01941 43.2139 0.519405 31.2139 0.0194046Z",
    fill: "#FDC73C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2139 0.0194046C21.6139 -0.380595 19.2139 5.5194 22.2139 7.0194C25.2139 8.51941 27.2139 8.0194 30.2139 8.0194C41.2139 8.0194 42.9366 6.90616 43.2139 5.51941C43.7139 3.01941 43.2139 0.519405 31.2139 0.0194046Z",
    fill: "url(#egg_paint0_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8616 1.30458C30.9399 1.68316 30.6965 2.05356 30.3179 2.13188C29.727 2.25414 29.1472 2.26758 28.6195 2.26779C28.518 2.26782 28.4191 2.26741 28.3223 2.26701C27.8965 2.26523 27.5099 2.26362 27.1185 2.3013C26.1404 2.39549 25.2412 2.85924 24.4997 3.56701C24.2201 3.83395 23.777 3.82365 23.5101 3.544C23.2431 3.26435 23.2534 2.82125 23.5331 2.55432C24.4599 1.66964 25.6411 1.0371 26.9843 0.907747C27.4525 0.86266 27.9243 0.864914 28.3532 0.866963C28.4439 0.867396 28.5326 0.867819 28.6189 0.867785C29.1334 0.867583 29.5921 0.8524 30.0343 0.760919C30.4129 0.682592 30.7833 0.925996 30.8616 1.30458Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.313 4.25551C22.675 4.11977 23.0785 4.30317 23.2143 4.66516C23.2146 4.666 23.2149 4.66685 23.2152 4.66769C23.2175 4.67114 23.2197 4.67461 23.2219 4.67809C23.3296 4.84731 23.3771 5.07727 23.3002 5.30896C23.2231 5.54145 23.0544 5.67942 22.9144 5.74945C22.6185 5.89738 22.268 5.81613 22.0646 5.57299C22.0117 5.51759 21.9717 5.45824 21.9426 5.40159C21.896 5.31124 21.8503 5.16154 21.8638 4.99564C21.8253 4.68207 22.0042 4.37133 22.313 4.25551Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "egg_paint0_linear",
    x1: 32,
    y1: -7,
    x2: 32,
    y2: 11.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEgg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/egg.e6b72d92.svg";
export { ForwardRef as ReactComponent };